import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes.js'
import {
  notifyExternalServices,
  ACTIONS,
} from '@/services/external-communication/external-communication'

Vue.use(VueRouter)

/**
 * Parses location.pathname to retrieve base path by using the language part.
 * E.g. for "/de-de/checkout" it would use "/de-de/" as base path.
 */
function getAppBase() {
  const p = window.location.pathname.split('/')
  return p[1] ? `/${p[1]}/` : '/'
}

const router = new VueRouter({
  mode: 'history',
  base: getAppBase(), // base for vue routing (everything beyond base path will be handled by vue router)
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition // Keep saved position when the browser's back and forward button is used
    } else if (to.name !== from.name) {
      return { x: 0, y: 0 } // Scroll to top of the screen when a route change happens
    }
  },
})

router.beforeEach((to, from, next) => {
  // Initial page load must not be reported as virtPath
  if (from.name === null) return next()

  const isTrackingVirtPathInView = to.matched.some(record => record.meta.isTrackingVirtPathInView)

  if (!isTrackingVirtPathInView) {
    notifyExternalServices({
      action: ACTIONS.virtPath,
      details: {
        virtPagePath: to.path,
        virtPageTitle: document.title,
      },
    })
  }
  next()
})

router.afterEach(() => {
  Vue.$dyClient.updateHistoryState()
})

export default router
